import { ACTION_TYPES } from './constants';

const socketReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPES.SOCKET_CONNECTED:
      return {
        ...state,
        connected: true,
      };
    case ACTION_TYPES.SOCKET_DISCONNECTED:
      return {
        ...state,
        connected: false,
      };
    default: {
      return state;
    }
  }
};

export default socketReducer;
